<template>
	<Toast/>

	<!--<div class="background">
		<div class="shape"></div>
		<div class="shape"></div>
	</div>-->
	<form>
		<label for="userId">아이디</label>
		<InputText id="userId" v-model="user.userId" autofocus/>

		<label for="loginPwd" class="p-col-fixed" style="width:100px">암호</label>
		<Password id="loginPwd" v-model="user.loginPwd" :feedback="false" toggleMask/>

		<label for="userNm">이름</label>
		<InputText id="userNm" v-model="user.userNm"/>

		<label for="email">메일</label>
		<InputText id="email" v-model="user.email"/>

		<Button class="btn-join" @click="btnAct('SAVE')" label="가입하기"/>
	</form>
</template>

<script>
import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useRouter } from 'vue-router';
import UserService from '@/service/cm/UserService';

export default {
	setup() {
		const user = ref({});
		const token = ref();
		const router = useRouter();
		const toast = useToast();
		const userService= new UserService();

		const btnAct = (_act) => {
			switch(_act)
			{
				case "SAVE":
					alert('Save.....');
					//user.value.userGbCd = 'USERGB_MNG'; // 사용여부
					user.value.compSeq = 1; 
					user.value.useYn = 1; // 사용여부(yes)
					//user.value.lockedYn = 0; // 사용자계정 잠금여부(false)

					alert('# user.value = '+ JSON.stringify(user.value));

					userService.insertOne(user.value).then(data => {
						alert('after insertOne User data = '+ JSON.stringify(data));
						console.log(data);
						//localStorage.setItem('user', JSON.stringify(user.value));
						//window.sessionStorage.setItem(token,token.value);

						toast.add({severity:'success', summary: '성공', detail: '신규 사용자가 등록되었습니다', life: 3000});
						router.push({name: 'LoginPage', params: {}});  // LoginPage, MainPage
					});
					break;
				default:
					break;
			}
		}
		
		return { user, token, btnAct }
	}
}
</script>

<style lang="scss" scoped>
	*,
	*:before,
	*:after{
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.background{
		width: 430px;
		height: 700px;
		position: absolute;
		transform: translate(-50%,-50%);
		left: 50%;
		top: 50%;
	}
	.background .shape{
		height: 200px;
		width: 200px;
		position: absolute;
		border-radius: 50%;
	}

	.shape:first-child{
		background: linear-gradient(
			#1845ad,
			#23a2f6
		);
		left: -80px;
		top: -80px;
	}
	.shape:last-child{
		background: linear-gradient(
			to right,
			#ff512f,
			#f09819
		);
		right: -80px;
		bottom: -80px;
	}

	form{
		height: 700px;
		width: 400px;
		border-radius: 10px;
		padding-top: 100px;
		margin: 0 auto;
	}

	form *{
		letter-spacing: 0.5px;
		outline: none;
		border: none;
	}

	form h3{
		font-size: 32px;
		line-height: 42px;
		text-align: center;
	}

	label{
		display: block;
		margin-top: 30px;
		font-size: 16px;
	}
	label:first-child{
		margin-top: 0;
	}
	input{
		display: block;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 3px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
	}
	::placeholder{
		color: #e5e5e5;
	}
	.layout-topbar{
		left: 0;
	}
	.p-inputtext{
		display: block;
		height: 50px;
		width: 100%;
		background-color: white;
		border-radius: 10px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		border: 1px solid black;
		&:last-child {
            margin-bottom: 0;
        }
	}
	::placeholder{
		color: #e5e5e5;
	}

	.p-password {
		position: relative;
		display: inline-flex;
		width: 100%;
	}
	::placeholder{
		color: #e5e5e5;
	}
	::v-deep(.p-password input) {
		position: relative;
		display: inline-flex;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 10px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		border: 1px solid black;
		background-color: white;
	}

	.p-button {
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		color: #080710;
		padding: 15px 0;
		font-size: 18px;
		border-radius: 10px;
		cursor: pointer;

		&:not(.p-button-icon-only) {
            display: flex;
            width: 100%;
			padding-left: 10px;
			padding-right: 10px;
        }
	}

	button{
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		color: #080710;
		padding: 15px 0;
		font-size: 18px;
		border-radius: 10px;
		cursor: pointer;
	}

	.btn-join{
		background-color: #003e92;
		color: white;
		font-family: 'NotoSansKR-Bold';
		&:hover{
			background-color: #0F315F;
		}
	}
</style>